type Args = {
  keyframeName: string;
  keyframeGenerators: Array<
    (step: number, precision: number) => [string, string]
  >;
  precision?: number;
};

/**
 * Generates keyframes built using transforms for a wrapper and a content
 * element based on a given configuration.
 * This is especially relevant when constructing height transitions using
 * transform: scale() without skewing content.
 */
export function createTransformKeyframes({
  keyframeName,
  keyframeGenerators,
  precision = 100,
}: Args): string {
  let animation = "";
  let inverseAnimation = "";

  for (let step = 0; step <= precision; step++) {
    const transforms = keyframeGenerators.map((generator) =>
      generator(step, precision),
    );

    const percentage = (100 / precision) * step;

    animation += `${percentage}% { transform: ${transforms
      .map((it) => it[0])
      .filter((it) => !!it)
      .join(" ")} }\n`;
    inverseAnimation += `${percentage}% { transform: ${transforms
      .map((it) => it[1])
      .filter((it) => !!it)
      .join(" ")} }\n`;
  }

  return `
@keyframes ${keyframeName}-wrapper {
  ${animation}
}

@keyframes ${keyframeName}-content {
  ${inverseAnimation}
}
  `;
}
